<template>
  <div :class="getCardType">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Card',

  props: {
    type: {
      type: String,
      required: false,
      default: '',
    },

    filled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    getCardType() {
      const cardType = ['card', 'shadow-sm', 'p-2'];
      const availableTypes = ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'dark'];
      if (availableTypes.indexOf(this.type) !== -1) {
        cardType.push(`card-${this.type}`);
      }

      if (this.filled) {
        cardType.push('card-filled');
      }

      return cardType;
    },
  },
};
</script>
